import { useCurrentUserRole } from "Hooks/useCurrentUserAccessRole";
import { AccessRoleCodes, type AccessRoleCode } from "Models/AccessRoleCodes";
import DashboardPage from "Pages/DashboardPage";
import EmployeeInitiateKeypadPaymentPage from "Pages/Employee/EmployeeInitiateKeypadPaymentPage";
import MerchantInitiateKeypadPaymentPage from "Pages/Merchant/MerchantInitiateKeypadPaymentPage";
import { type Page, appUrl } from "Utils/UrlUtils";
import type { FC } from "react";

export const USER_ROLE_TO_HOMEPAGE: Record<
  AccessRoleCode,
  { page: Page; HomepageComponent: FC }
> = {
  [AccessRoleCodes.Merchant]: {
    page: "initiate-keypad-payment",
    HomepageComponent: MerchantInitiateKeypadPaymentPage,
  },
  [AccessRoleCodes.Hunter]: {
    page: "dashboard",
    HomepageComponent: DashboardPage,
  },
  [AccessRoleCodes.Customer]: {
    page: "dashboard",
    HomepageComponent: DashboardPage,
  },
  [AccessRoleCodes.Admin]: {
    page: "dashboard",
    HomepageComponent: DashboardPage,
  },
  [AccessRoleCodes.AdminLite]: {
    page: "dashboard",
    HomepageComponent: DashboardPage,
  },
  [AccessRoleCodes.Aml]: {
    page: "dashboard",
    HomepageComponent: DashboardPage,
  },
  [AccessRoleCodes.Employee]: {
    page: "employee-initiate-keypad-payment",
    HomepageComponent: EmployeeInitiateKeypadPaymentPage,
  },
  [AccessRoleCodes.CustomerOnboarding]: {
    page: "dashboard",
    HomepageComponent: DashboardPage,
  },
  [AccessRoleCodes.HunterPlus]: {
    page: "dashboard",
    HomepageComponent: DashboardPage,
  },
  [AccessRoleCodes.Disponent]: {
    page: "dashboard",
    HomepageComponent: DashboardPage,
  },
  [AccessRoleCodes.Child]: {
    page: "dashboard",
    HomepageComponent: DashboardPage,
  },
};

export const useCurrentUserHomepage = () => {
  const userRole = useCurrentUserRole();

  if (!userRole) {
    return { homepage: undefined, homepageUrl: undefined };
  }

  const { page, HomepageComponent } = USER_ROLE_TO_HOMEPAGE[userRole];

  return { HomepageComponent, homepageUrl: appUrl(page) };
};
